export const GET_THEMES_LIST_SUCCESS = 'THEMES/GET_THEMES_LIST_SUCCESS';
export const GET_THEMES_LIST_ERROR = 'THEMES/GET_THEMES_LIST_ERROR';
export const CLEAR_GET_THEMES_LIST = 'THEMES/CLEAR_GET_THEMES_LIST';

export const PATCH_CUSTOM_THEME_SUCCESS = 'THEMES/PATCH_CUSTOM_THEME_SUCCESS';
export const PATCH_CUSTOM_THEME_ERROR = 'THEMES/PATCH_CUSTOM_THEME_ERROR';
export const CLEAR_PATCH_CUSTOM_THEME = 'THEMES/CLEAR_PATCH_CUSTOM_THEME';

export const REPLICATE_EXISTING_THEME_SUCCESS = 'THEMES/REPLICATE_EXISTING_THEME_SUCCESS';
export const REPLICATE_EXISTING_THEME_ERROR = 'THEMES/REPLICATE_EXISTING_THEME_ERROR';
export const CLEAR_REPLICATE_EXISTING_THEME = 'THEMES/CLEAR_REPLICATE_EXISTING_THEME';
